export default class Stage {
  async run() {
  }
}
